import React from "react";
import { Redirect, Switch } from "react-router-dom";
import "./Routes.scss";
import loadable from "@loadable/component";
import {trackPage} from "analytics";
import Header from "components/Header/Header";


import { useQuery } from "react-query";
import {TRANSPORTISTA} from "api/TYPES";
import {crudFunctions, getUser} from "api";
import { createState, useState } from '@hookstate/core';
import {userStore, useUserStore} from 'api/store';
import PortalNoAutorizado from "pages/Login/PortalNoAutorizado";
import {portalConfig, puedeAccederPortal} from "portal";

import { CircularProgress } from "@material-ui/core";
const fallback = ()=> <CircularProgress />

const Home = loadable(() => import("../pages/Home/Home"),fallback);
const NavBar = loadable(() => import("../components/NavBar/VNavBar"));
const InitialData = loadable(() => import("../pages/Login/InitialData"),fallback);
const InitialFiles = loadable(() => import("../pages/Login/InitialFiles"),fallback);
const EnRevision = loadable(() => import("../pages/Login/EnRevision"),fallback);
const Bloqueado = loadable(() => import("../pages/Login/Bloqueado"),fallback);
const Flotilla = loadable(() => import("../pages/Flotilla/Flotilla"),fallback);
const TablaViajes = loadable(() => import("../pages/Viaje/TabsViajes"),fallback);
const Viaje = loadable(() => import("../pages/Viaje/Viaje"),fallback);
const Portuarios = loadable(() => import("../pages/Portuarios/Portuarios"),fallback);
const Portuario = loadable(() => import("../pages/Portuarios/Portuario"),fallback);
const TarifasPuertos = loadable(() => import("../pages/TarifasPuertos/TarifasPuertos"),fallback);
const TablaPagos = loadable(() => import("../pages/Pago/TablaPagos"),fallback);
const TablaSolicitudes = loadable(() => import("../pages/Solicitudes/TablaSolicitudes"),fallback);
const MiInformacion = loadable(() => import("../pages/Configuracion/MiInformacion"),fallback);
const TablaSeguros = loadable(() => import("../pages/Seguros/TablaSeguros"),fallback);
const NuevoSeguro = loadable(() => import("../pages/Seguros/NuevoSeguro/NuevoSeguro"),fallback);

const Activar = loadable(() => import("../pages/Login/Activar"),fallback);
const Login = loadable(() => import("../pages/Login/Login"),fallback);
const Registro = loadable(() => import("../pages/Login/Registro"),fallback);
const Forgot = loadable(() => import("../pages/Login/Olvide"),fallback);
const Reset = loadable(() => import("../pages/Login/Reset"),fallback);
const PrivateRoute = loadable(() => import("./PrivateRoute/PrivateRoute"));
const PublicRoute = loadable(() => import("./PublicRoute/PublicRoute"));

const PortalHome = () => portalConfig.features.viajesNacionales
	? <Home />
	: <Redirect to={portalConfig.homePath} />;



const Routes = () => {
	const {data:user, status:s2} = useQuery(TRANSPORTISTA.name, getUser);

	// const {user} = useUserStore();
	const state = useState(userStore);
	const status = state.status.get();
	const loggedIn = state.loggedIn.get();
	// const user = state.user.get();
	
	console.log({ user, s2})
	React.useEffect(()=>{
		let path = window.location.pathname;
		const myregexp = /[0-9a-fA-F]{24}/g;
		path = path.replace(myregexp, "id");
		trackPage(path);
	},[window.location.pathname]);

	const currentPath = window.location.pathname;
	const isPublicPath = currentPath === "/login"
		|| currentPath === "/registro"
		|| currentPath === "/forgot"
		|| currentPath.startsWith("/reset")
		|| currentPath.startsWith("/activar");
	let RNavBar = isPublicPath ? null : <><NavBar user={user} /></>;

	// if (status==="loading")return <>Loading</>;
	// if (status==="error")return <>Error</>;
	// if (status==="error"){
	// 	return <>
	// 		<PublicRoute user={user} exact path="/login" component={Login} />
	// 		<PublicRoute user={user} exact path="/registro" component={Registro} />
	// 		<PublicRoute user={user} exact path="/forgot" component={Forgot} />
	// 		<PublicRoute user={user} exact path="/reset/:token/:idNutriologo" component={Reset} />
	// 	</>;
	// }
	if (status==="loading")return <>Loading</>;
	if(loggedIn && user?.transportista && !puedeAccederPortal(user.transportista, portalConfig.tipoOperacion)){
		return <PortalNoAutorizado transportista={user.transportista} />;
	}

	if(user?.transportista?.status==="pendiente_documentos")return <>
		<Redirect to={{ pathname: "/pendiente-documentos" }} />
		{RNavBar}
		<div className="container">
			<InitialFiles />
		</div>
	</>;
	else if(user?.transportista?.status==="en_revision")return <>
		<Redirect to={{ pathname: "/en-revision" }} />
		{RNavBar}
		<div className="container">
			<EnRevision />
		</div>
	</>;
	else if(user?.transportista?.status==="bloqueado")return <>
		{/* <Redirect to={{ pathname: "/en-revision" }} /> */}
		{RNavBar}
		<div className="container">
			<Bloqueado />
		</div>
	</>;
	else if(user?.transportista?.status==="pendiente_informacion")return <><Redirect to={{ pathname: "/pendiente-informacion" }} />  {RNavBar}<InitialData /></>;
	
	return (
		<>
			{RNavBar}

			<div style={{height:"100%", minHeight:"100vh"}}>
				<div style={{height:"100%"}} className={isPublicPath ? "" : "container-app"}>
					<Switch>
						<PublicRoute status={status} user={user} loggedIn={loggedIn} exact path="/login" component={Login} />
						<PublicRoute status={status} user={user} loggedIn={loggedIn} exact path="/registro" component={Registro} />
						<PublicRoute status={status} user={user} loggedIn={loggedIn} exact path="/forgot" component={Forgot} />
						<PublicRoute status={status} user={user} loggedIn={loggedIn} exact path="/reset/:token/:id" component={Reset} />
						<PublicRoute status={status} user={user} loggedIn={loggedIn} exact path="/activar/:token/:idUsuario" component={Activar} />

						<PrivateRoute status={status} user={user} loggedIn={loggedIn} exact path="/" component={PortalHome} />
						<PrivateRoute status={status} user={user} loggedIn={loggedIn} path="/setup" component={InitialData} />
						<PrivateRoute status={status} exact user={user} loggedIn={loggedIn} path="/flotilla/:seccion?" component={Flotilla} />
						<Redirect exact from="/conductores" to="/flotilla/0" />
						<Redirect exact from="/unidades" to="/flotilla/1" />
						{portalConfig.features.equipos && <Redirect exact from="/equipos" to="/flotilla/2" />}
						{portalConfig.features.viajesNacionales && <PrivateRoute status={status} exact user={user} loggedIn={loggedIn} path="/viajes/:seccion?" component={TablaViajes} />}
						{portalConfig.features.viajesNacionales && <PrivateRoute status={status} exact user={user} loggedIn={loggedIn} path="/viaje/:id/:seccion?" component={Viaje} />}
						{portalConfig.features.viajesPortuarios && <PrivateRoute status={status} exact user={user} loggedIn={loggedIn} path="/portuarios/:id/:seccion?" component={Portuario} />}
						{portalConfig.features.viajesPortuarios && <PrivateRoute status={status} exact user={user} loggedIn={loggedIn} path="/portuarios" component={Portuarios} />}
						{portalConfig.features.tarifasPuertos && <PrivateRoute status={status} exact user={user} loggedIn={loggedIn} path="/tarifas-puertos" component={TarifasPuertos} />}
						<PrivateRoute status={status} user={user} loggedIn={loggedIn} path="/pagos" component={TablaPagos} />
						<PrivateRoute status={status} user={user} loggedIn={loggedIn} path="/solicitudes" component={TablaSolicitudes} />
							<PrivateRoute status={status} user={user} loggedIn={loggedIn} path="/mis-documentos" component={InitialFiles} />
							<Redirect from="/perfil/:seccion?" to="/mi-informacion/:seccion?" />
							<PrivateRoute status={status} user={user} loggedIn={loggedIn} path="/mi-informacion/:seccion?" component={MiInformacion} />
							<Redirect exact from="/usuarios" to="/mi-informacion" />
						<PrivateRoute status={status} user={user} loggedIn={loggedIn} path="/seguros" component={TablaSeguros} />
						<PrivateRoute status={status} user={user} loggedIn={loggedIn} path="/nuevo-seguro" component={NuevoSeguro} />
						<Redirect to={portalConfig.homePath} />
					</Switch>
				</div>
			</div>
		</>
	);
	
	
};

export default Routes;
